function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .action-opps-aarp_svg__action-opps-aarp_svg__cls-1{fill:none}.action-opps-aarp_svg__action-opps-aarp_svg__cls-2{clip-path:url(#action-opps-aarp_svg__action-opps-aarp_svg__clip-path)}.action-opps-aarp_svg__action-opps-aarp_svg__cls-3{clip-path:url(#action-opps-aarp_svg__action-opps-aarp_svg__clip-path-2)}.action-opps-aarp_svg__action-opps-aarp_svg__cls-4{fill:url(#action-opps-aarp_svg__action-opps-aarp_svg__linear-gradient)}.action-opps-aarp_svg__action-opps-aarp_svg__cls-5{clip-path:url(#action-opps-aarp_svg__action-opps-aarp_svg__clip-path-3)}.action-opps-aarp_svg__action-opps-aarp_svg__cls-6{fill:#ee3224}.action-opps-aarp_svg__action-opps-aarp_svg__cls-7{clip-path:url(#action-opps-aarp_svg__action-opps-aarp_svg__clip-path-4)}\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "action-opps-aarp_svg__action-opps-aarp_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  className: "action-opps-aarp_svg__action-opps-aarp_svg__cls-1",
  d: "M70.82,4.24,50.25,54.48c7.81-.53,16.3-2.41,22.15-2.87L90,4.24Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "action-opps-aarp_svg__action-opps-aarp_svg__clip-path-2"
}, /*#__PURE__*/React.createElement("rect", {
  className: "action-opps-aarp_svg__action-opps-aarp_svg__cls-1",
  x: 50.25,
  y: 4.24,
  width: 39.72,
  height: 50.24
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "action-opps-aarp_svg__action-opps-aarp_svg__linear-gradient",
  x1: -17.38,
  y1: 153.28,
  x2: -16.38,
  y2: 153.28,
  gradientTransform: "matrix(63.37, 0, 0, -63.37, 1164.46, 9654.65)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ee3224"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#ee3224"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ee3224"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "action-opps-aarp_svg__action-opps-aarp_svg__clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "action-opps-aarp_svg__action-opps-aarp_svg__cls-1",
  d: "M70.8,4.25,50.23,54.49c7.82-.54,16.3-2.42,22.15-2.88L90,4.25Z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "action-opps-aarp_svg__action-opps-aarp_svg__clip-path-4"
}, /*#__PURE__*/React.createElement("path", {
  className: "action-opps-aarp_svg__action-opps-aarp_svg__cls-1",
  d: "M42.82,72.59c8.94.44,18.93-1.52,22.64-2.21l-5.7,15.43H37.43Z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "action-opps-aarp_svg__action-opps-aarp_svg__cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "action-opps-aarp_svg__action-opps-aarp_svg__cls-3"
}, /*#__PURE__*/React.createElement("rect", {
  className: "action-opps-aarp_svg__action-opps-aarp_svg__cls-4",
  x: 62.95,
  y: -88.69,
  width: 190.1,
  height: 190.1,
  transform: "translate(73.49 140.01) rotate(-60)"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-aarp_svg__action-opps-aarp_svg__cls-6",
  d: "M42.81,72.6c8.93.44,18.92-1.52,22.64-2.22l-5.7,15.44H37.41Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-aarp_svg__action-opps-aarp_svg__cls-6",
  d: "M114.22,78.69a60.51,60.51,0,0,0-16-6.59l4.94,13.72h30.37l6.71-18.06a95.19,95.19,0,0,1,15.17-1.3,85.91,85.91,0,0,1,14.92,1.34l6.55,18h59.55V53l24.92,32.85h61.75V61.63h13.67c22.72,0,36.52-11.23,36.52-28.69,0-16.57-12.58-28.69-36.52-28.69H293.5V82.47L270.25,57.2c3.57-1.63,16.42-7.93,16.42-24.26S273.45,4.25,246.47,4.25H206.79V79.53l-29-75.28H144.58L123.69,55.4,104,4.25H73.67L90.83,51.59a71.59,71.59,0,0,0-13.16-1.15c-16.47,0-21.77,2.93-35.08,2.93C24.2,53.37,8.23,43.06,6.57,42L.2,57.58A76.32,76.32,0,0,0,41.64,69.85c14.78,0,23.82-3.48,38.05-3.48a71.29,71.29,0,0,1,35.79,9.21Zm41.21-51.9,9.08,24.28a78.77,78.77,0,0,0-9.08-.62c-3.85,0-8.83.57-9.25.62Zm81,21.35V17.7h4.35c11.31,0,15.39,7.14,15.39,15.24,0,9.42-5.21,15.2-15.39,15.2Zm86.67,0V17.7h6c9,0,13.69,6.37,13.69,15.24,0,9.49-5.25,15.2-13.69,15.2Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-aarp_svg__action-opps-aarp_svg__cls-6",
  d: "M378.26,4.11h3.06c1.94,0,3.4.69,3.4,2.73s-1.46,2.88-3.4,2.88h-1.6v3.83h-1.46Zm2.89,4.44c1.37,0,2.13-.57,2.13-1.71s-.76-1.57-2.13-1.57h-1.43V8.55Zm1-.05L385,13.55H383.4L381,9.33Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "action-opps-aarp_svg__action-opps-aarp_svg__cls-6",
  d: "M381.15,17.48a8.65,8.65,0,1,1,8.65-8.65A8.66,8.66,0,0,1,381.15,17.48Zm0-15.8a7.15,7.15,0,1,0,7.15,7.15A7.16,7.16,0,0,0,381.15,1.68Z"
});

function SvgActionOppsAarp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "action-opps-aarp_svg__action-opps-aarp_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 390 86"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgActionOppsAarp;